import { notify } from 'utils/reduxUtils';

export const types = {
  FETCH_QUOTE_VIEWS_ERROR: 'FETCH_QUOTE_VIEWS_ERROR',
  FETCH_QUOTE_VIEWS_REQUEST: 'FETCH_QUOTE_VIEWS_REQUEST',
  FETCH_QUOTE_VIEWS_SUCCESS: 'FETCH_QUOTE_VIEWS_SUCCESS',
};

export const fetchQuoteViews = {
  error: notify(
    (error) => ({
      type: types.FETCH_QUOTE_VIEWS_ERROR,
      payload: error,
    }),
    "Can't fetch quote views",
  ),
  request: (quoteId) => ({
    type: types.FETCH_QUOTE_VIEWS_REQUEST,
    payload: { quoteId },
  }),
  success: (payload) => ({
    type: types.FETCH_QUOTE_VIEWS_SUCCESS,
    payload: payload,
  }),
};
